import React from "react"
import ReactDOM from "react-dom/client"
import "./index.scss"
import App from "./App"
import * as serviceWorkerRegistration from "./serviceWorkerRegistration"
import reportWebVitals from "./reportWebVitals"

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement)

root.render(
  <React.StrictMode>
    {/* {process.env.NODE_ENV === "production" && (
      <>
        <script
          async
          src="https://www.googletagmanager.com/gtag/js?id=REPLACE-THIS" 
          // TODO update id
        />
        <script
          dangerouslySetInnerHTML={{
            __html: `
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag(‘js’, new Date());
              gtag(‘config’, 'REPLACE-THIS'); TODO update id
            `,
          }}
        />
      </>
    )} */}
    <App />
  </React.StrictMode>
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister()

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()

